import styled from 'styled-components'

import { IconButtonStyled } from '@ui/elements/Button/styles/IconButtonStyled'
import { IconComponentStyled } from '@ui/elements/Icon/styles/IconComponentStyled'
import { IconStyled } from '@ui/elements/Icon/styles/IconStyled'

const BUTTON_SIZE = 16
const ICON_SIZE = 8

export const QuantityCounterButtonStyled = styled(IconButtonStyled)`
  width: ${({ theme }) => theme.typography.pxToRem(BUTTON_SIZE)};
  height: ${({ theme }) => theme.typography.pxToRem(BUTTON_SIZE)};
  padding: 0;

  border: none;
  background-color: transparent;
  box-shadow: none;

  > ${IconStyled}, > ${IconComponentStyled} {
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.typography.pxToRem(ICON_SIZE)};
  }

  &:hover:not([disabled]) {
    background-color: transparent;
    box-shadow: none;

    > ${IconStyled}, > ${IconComponentStyled} {
      color: ${({ theme }) => theme.colors.text.primary};
    }
  }

  &:active:not([disabled]) {
    background-color: transparent;
    box-shadow: none;

    > ${IconStyled}, > ${IconComponentStyled} {
      color: ${({ theme }) => theme.colors.text.primary};
    }
  }

  &[disabled] {
    background-color: transparent;
    border: none;
    box-shadow: none;

    > ${IconStyled}, > ${IconComponentStyled} {
      color: ${({ theme }) => theme.colors.text.disabled};
    }

    &:hover {
      background-color: transparent;
      box-shadow: none;

      > ${IconStyled}, > ${IconComponentStyled} {
        color: ${({ theme }) => theme.colors.text.disabled};
      }
    }
  }
`
